import { rei } from "@/services/api"

class SolicitantesService {
  static getSolicitantes (params = null) {
    if (params == null) {
      return rei.get(`solicitantes`).then(res => res.data)
    } else {
      let query = []
      query.push(params.perPage ? 'perPage=' + params.perPage : '')
      query.push(params.page ? 'page=' + params.page : '')
      query.push(params.nome ? 'nome=' + params.nome : '')
      query.push(params.cpf ? 'cpf=' + params.cpf : '')
      query.push(params.cartorio_id ? 'cartorio_id=' + params.cartorio_id : '')
      return rei.get(`solicitantes?${query.join('&')}`).then(res => res.data)
    }
  }

  static saveSolicitantes (solicitante) {
    return rei.post(`solicitantes`, solicitante).then(res => res.data)
  }

  static updateSolicitantes (solicitante, id) {
    return rei.post(`solicitantes/${id}`, solicitante).then(res => res.data)
  }

  static excludeSolicitantes (id) {
    return rei.post(`solicitantes/${id}`)
  }
}

export default SolicitantesService
